import { types } from 'mobx-state-tree';

import Views from './Views';

const FreeTrial = types
  .model({
    startDate: types.maybeNull(types.Date),
    endDate: types.maybeNull(types.Date),
    isExpired: types.maybeNull(types.boolean),
    isStarted: types.maybeNull(types.boolean),
    eligibleForFreeTrial: types.optional(types.boolean, false),
    source: types.maybeNull(types.string),
  })
  .views(Views);

export default FreeTrial;
